const activity = {
  activity: "活動", // translated
  activities: "活動内容", // translated
  dates: "日付", // translated
  location: "位置", // translated
  languages: "言語", // translated
  categories: "カテゴリー", // translated
  ticketOption: "チケットオプション", // translated
  numberOfRatings: "評価数", // translated
  meetingPointInfo: "集合場所の情報", // translated
  meetingPoint: "ミーティングポイント", // translated
  meetingPoints: "集合場所", // translated
  providedBy: "提供企業", // translated
  expirationDate: "有効期限", // translated
  groupSize: "グループの規模", // translated
  features: "特徴", // translated
  basedOn: "に基づく", // translated
  reviewsFromVerCustomers: "検証済みの顧客からのレビュー", // translated
  excellent: "素晴らしい", // translated
  great: "素晴らしい", // translated
  average: "平均", // translated
  poor: "貧しい", // translated
  bad: "悪い", // translated
  onlyBookedCustomersTooltip: "このアクティビティを予約したお客様のみがレビューを残すことができます", // translated
  noReviewsYet: "現時点では、このアクティビティに関するレビューはありません。", // translated
  backToActivitiesList: "活動リストに戻る", // translated
  getPrices: "予約にすすむ", // translated
  availabilityAndPrices: "在庫状況と価格", // translated
  ticketOptions: "チケットオプション", // translated
  ticketInfo: "チケット情報", // translated
  selectYourTickets: "選択してください", // translated
  product: "製品", // translated
  total: "合計", // translated
  slot: "時間", // translated
  language: "言語", // translated
  tickets: "チケット", // translated
  ticketsFor: "のチケット", // translated
  previousStep: "一つ前の手順", // translated
  onlyAvailableInEnglish: "英語のみで利用可能", // translated
  guest: "ゲスト", // translated
  leadGuest: "リードゲスト", // translated
  adult: "搭乗者情報", // translated
  child: "子供", // translated
  pleaseSelectAdult: "大人を少なくとも 1 名選択してください", // translated
  notAvailableActivity: "この製品は利用できません", // translated
  required: "必須", // translated
  pickupPoint: "集荷場", // translated
  pickupPoints: "受け取りポイント", // translated
  ticketType: "チケットの種類", // translated
  anonymous: "匿名", // translated
  printedVoucher: "印刷されたバウチャーが受け入れられました", // translated
  mobileVoucher: "モバイルクーポンが利用可能になりました", // translated
  mixedVoucher: "モバイルまたは印刷されたバウチャーをご利用いただけます", // translated
  safetyMeasures: "安全対策が施されています", // translated
  doThisBecause: "アクティビティ", // translated
  safetyInfo: "安全性に関する情報", // translated
  reviewsHighestFirst: "レビューの数 (多い順)", // translated
  bookingFee: "予約料", // translated
  startDate: "開始日", // translated
  endDate: "終了日", // translated
  cancellationDeadlineAndFees: "キャンセル期限と手数料", // translated
  resetTickets: "チケットをリセットする", // translated
  instantConfirmation: "即時確認", // translated
  clickResetBtn: "選択をやり直すにはリセット ボタンをクリックしてください", // translated
  whatToRemember: "What to remember", // translated
};



export default activity;
